import { Injectable } from '@angular/core';

/**
 * Detecta se o app está rodando como PWA instalada (standalone / minimal-ui /
 * fullscreen / Chrome --app), em oposição a uma aba normal de navegador.
 *
 * Cobre os dois caminhos comuns:
 *  - `display-mode` media query (Chrome, Edge, Firefox, Safari atual)
 *  - `navigator.standalone` (iOS Safari — flag de "Adicionar à Tela de Início")
 *
 * Uso típico: o `AppComponent` consulta `isInstalledApp` no init e adiciona
 * a classe `installed-app` ao `<body>`, permitindo SCSS condicional como
 * `body.installed-app .navbar { border-top: ... }`.
 */
@Injectable({ providedIn: 'root' })
export class PlatformService {
  readonly isInstalledApp: boolean;

  constructor() {
    this.isInstalledApp = this.detect();
  }

  private detect(): boolean {
    if (typeof window === 'undefined') { return false; }
    const standaloneMedia =
      window.matchMedia('(display-mode: standalone)').matches ||
      window.matchMedia('(display-mode: minimal-ui)').matches ||
      window.matchMedia('(display-mode: fullscreen)').matches;
    const iosStandalone = (window.navigator as { standalone?: boolean }).standalone === true;
    return standaloneMedia || iosStandalone;
  }
}
